import React from "react";

const baseSvgProps = {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	"aria-hidden": true,
};

function IconWrap({ className, style, children, ...props }) {
	return (
		<svg {...baseSvgProps} className={className} style={{ width: 24, height: 24, display: "inline-block", verticalAlign: "middle", ...style }} {...props}>
			{children}
		</svg>
	);
}

export function SvgIcon({ name, className, style, ...props }) {
	const icons = {
		warning: (
			<IconWrap className={className} style={style} {...props}>
				<path d="M12 8.5V12.5" />
				<path d="M12 16.5H12.01" />
				<path d="M10.29 3.86 1.82 18A2 2 0 0 0 3.53 21h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
			</IconWrap>
		),
		gear: (
			<IconWrap className={className} style={style} {...props}>
				<circle cx="12" cy="12" r="3.25" />
				<path d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 0 1 0 2.82 2 2 0 0 1-2.82 0l-.06-.06A1.7 1.7 0 0 0 15 19.4a1.7 1.7 0 0 0-1.4 1.4 1.7 1.7 0 0 0-.07.57v.17a2 2 0 0 1-3.06 1.79 2 2 0 0 1-.94-1.79v-.17a1.7 1.7 0 0 0-.07-.57A1.7 1.7 0 0 0 8.85 19.4a1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 0 1-2.82 0 2 2 0 0 1 0-2.82l.06-.06A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-1.4-1.4 1.7 1.7 0 0 0-.57-.07H2.46A2 2 0 0 1 .67 12.18a2 2 0 0 1 1.79-3.06h.17a1.7 1.7 0 0 0 .57-.07A1.7 1.7 0 0 0 4.6 7.65a1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 0 1 0-2.82 2 2 0 0 1 2.82 0l.06.06A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1.4-1.4 1.7 1.7 0 0 0 .07-.57V2.46A2 2 0 0 1 12.18.67a2 2 0 0 1 3.06 1.79v.17a1.7 1.7 0 0 0 .07.57A1.7 1.7 0 0 0 16.35 4.6a1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 0 1 2.82 0 2 2 0 0 1 0 2.82l-.06.06A1.7 1.7 0 0 0 19.4 8.85a1.7 1.7 0 0 0 1.4 1.4 1.7 1.7 0 0 0 .57.07h.17a2 2 0 0 1 1.79 3.06 2 2 0 0 1-1.79 1.05h-.17a1.7 1.7 0 0 0-.57.07A1.7 1.7 0 0 0 19.4 15Z" />
			</IconWrap>
		),
		power: (
			<IconWrap className={className} style={style} {...props}>
				<path d="M9 2.5v7" />
				<path d="M6.2 4.7a8.5 8.5 0 1 0 11.6 0" />
			</IconWrap>
		),
		dashboard: (
			<IconWrap className={className} style={style} {...props}>
				<path d="M4 13.5h7V20H4z" />
				<path d="M13 4h7v8h-7z" />
				<path d="M13 14h7v6h-7z" />
				<path d="M4 4h7v6H4z" />
			</IconWrap>
		),
		back: (
			<IconWrap className={className} style={style} {...props}>
				<path d="M14.5 6.5 8.5 12l6 5.5" />
				<path d="M18.5 12H8.5" />
			</IconWrap>
		),
		save: (
			<IconWrap className={className} style={style} {...props}>
				<path d="M5 4.5h11l3 3v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1Z" />
				<path d="M8 4.5v4h8v-4" />
				<path d="M9 15.5h6" />
			</IconWrap>
		),
		refresh: (
			<IconWrap className={className} style={style} {...props}>
				<path d="M20 11a8 8 0 1 0 2.3 5.7" />
				<path d="M20 4v7h-7" />
			</IconWrap>
		),
		plus: (
			<IconWrap className={className} style={style} {...props}>
				<path d="M12 5v14" />
				<path d="M5 12h14" />
			</IconWrap>
		),
		edit: (
			<IconWrap className={className} style={style} {...props}>
				<path d="M4 20h4l10-10-4-4L4 16v4Z" />
				<path d="m13 5 4 4" />
			</IconWrap>
		),
		wallet: (
			<IconWrap className={className} style={style} {...props}>
				<path d="M3 7.5A2.5 2.5 0 0 1 5.5 5H18a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5.5A2.5 2.5 0 0 1 3 16.5v-9Z" />
				<path d="M16 12h5" />
				<path d="M3 9.5h15.5A2.5 2.5 0 0 1 21 12v.5" />
			</IconWrap>
		),
		chart: (
			<IconWrap className={className} style={style} {...props}>
				<path d="M4 18.5h16" />
				<path d="M7 15V9" />
				<path d="M12 15V5" />
				<path d="M17 15v-7" />
			</IconWrap>
		),
		trash: (
			<IconWrap className={className} style={style} {...props}>
				<path d="M4 7h16" />
				<path d="M8 7V4h8v3" />
				<path d="M6 7l1 12h10l1-12" />
			</IconWrap>
		),
		check: (
			<IconWrap className={className} style={style} {...props}>
				<path d="m5 12 4.2 4.2L19 2.5" />
			</IconWrap>
		),
		search: (
			<IconWrap className={className} style={style} {...props}>
				<circle cx="11" cy="11" r="5.5" />
				<path d="m16 16 4.5 4.5" />
			</IconWrap>
		),
		info: (
			<IconWrap className={className} style={style} {...props}>
				<circle cx="12" cy="12" r="8" />
				<path d="M12 10v6" />
				<path d="M12 7.5h.01" />
			</IconWrap>
		),
		xmark: (
			<IconWrap className={className} style={style} {...props}>
				<path d="m6 6 12 12" />
				<path d="M18 6 6 18" />
			</IconWrap>
		),
		coin: (
			<IconWrap className={className} style={style} {...props}>
				<circle cx="12" cy="12" r="7.5" />
				<path d="M9.5 10.5c0-1.1.9-2 2-2h1c1.1 0 2 .9 2 2s-.9 2-2 2h-1c-1.1 0-2 .9-2 2s.9 2 2 2h1c1.1 0 2-.9 2-2" />
			</IconWrap>
		),
		trophy: (
			<IconWrap className={className} style={style} {...props}>
				<path d="M8 4h8v2a4 4 0 0 1-8 0V4Z" />
				<path d="M8 4H5a1 1 0 0 0-1 1v1a4 4 0 0 0 4 4" />
				<path d="M16 4h3a1 1 0 0 1 1 1v1a4 4 0 0 1-4 4" />
				<path d="M12 13v4" />
				<path d="M9 20h6" />
			</IconWrap>
		),
		moon: (
			<IconWrap className={className} style={style} {...props}>
				<path d="M20 12.5A7.5 7.5 0 0 1 11.5 4a8 8 0 1 0 8.5 8.5Z" />
			</IconWrap>
		),
		calculator: (
			<IconWrap className={className} style={style} {...props}>
				<rect x="5" y="3" width="14" height="18" rx="2" />
				<path d="M9 7h6" />
				<path d="M9 11h.01" />
				<path d="M12 11h.01" />
				<path d="M15 11h.01" />
				<path d="M9 15h.01" />
				<path d="M12 15h.01" />
				<path d="M15 15h.01" />
			</IconWrap>
		),
		users: (
			<IconWrap className={className} style={style} {...props}>
				<path d="M16 19v-1a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v1" />
				<circle cx="10" cy="7" r="3" />
				<path d="M20 19v-1a4 4 0 0 0-3-3.87" />
				<path d="M16 4.13a4 4 0 0 1 0 7.74" />
			</IconWrap>
		),
	};

	return icons[name] || null;
}
